import { useQuery } from "react-query";
import { SrxApi } from "../../api/SrxApi";
import { useQueryClient } from "react-query";

const useGetData = (versionId, pageNumber = 1, pageSize = 10, url, queryParams = {}) => {
  const queryClient = useQueryClient();
  const getAllData = async () => {
    const response = await SrxApi.get(url, {
      params: {
        pageNumber,
        pageSize,
        ...queryParams,
      },
      paramsSerializer: params => {
        return Object.entries(params)
          .flatMap(([key, value]) => {
            if (Array.isArray(value)) {
              return value.map(v => `${key}=${encodeURIComponent(v)}`);
            }
            return `${key}=${encodeURIComponent(value)}`;
          })
          .join('&');
      }
    });
    return response?.data ?? { items: [], totalCount: 0, pageNumber: 1, pageSize: 10, totalPages: 0 };
  };

  const {
    data: getData = { items: [], totalCount: 0, pageNumber: 1, pageSize: 10, totalPages: 0 },
    isFetching: getAllDataLoading,
  } = useQuery(
    [ versionId, pageNumber, pageSize, url, queryParams],
    getAllData,
    {
      enabled: !!versionId && !!url,
      staleTime: 1000 * 60 * 5,
      keepPreviousData: true,
      refetchOnWindowFocus: true,
    }
  );
  const refetchData = () => {
    queryClient.invalidateQueries([versionId, pageNumber, pageSize, url, queryParams]);
  };
  return {
    getData,
    getAllDataLoading,
    refetchData
  };
};

export default useGetData;
